import { Component, Inject, inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, Event, NavigationStart, RouterOutlet, NavigationEnd } from "@angular/router";
import { ThemeOptions } from './theme-options'
import { Analytics, logEvent } from '@angular/fire/analytics';
import { environment } from 'src/environments/environment'
import { Title } from '@angular/platform-browser';
import { AppState } from './app-state';
import { WebSocketService } from './web-socket-handlers/web-socket.service';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
// import { WebSocketService } from './web-socket-handlers/web-socket.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  allowedUnauthenticatedRoutes: string[] = ['/', '/sign-in', '/sign-in/:invitationId', '/sign-up', '/sign-up/:invitationId', '/forgot-password', '/reset-password', '/terms', '/invitation/:id']

  title = 'American Drone Network Admin Portal'
  // private analytics: Analytics | null = environment.firebase.enableAnalytics ? inject(Analytics) : null

  constructor(
    public globals: ThemeOptions,
    private router: Router,
    private titleService: Title,
    private appState: AppState,
    private webSocketService: WebSocketService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // const title = environment.htmlTitle || this.title
    // this.titleService.setTitle(title)

    this.router.events.subscribe((event:Event) => {

      if (event instanceof NavigationStart) {
        // if (this.globals.toggleSidebarMobile) {
        //   this.globals.toggleSidebar = true
        //   this.globals.toggleSidebarMobile = false
        // }
        // this.globals.sidebarHover = false
        // this.globals.toggleHeaderMobile = false

        // check the body element and remove any classes and styles that may have been added by the previous page
        // const body = document.querySelector('body')
        // if (body) {
        //   body.removeAttribute('style')
        // }
      }

      if (event instanceof NavigationEnd) {
        const offcanvasElement = document.querySelector('.offcanvas-lg.show') as HTMLElement

        if (offcanvasElement) {
          const angularBootstrap = (window as any).bootstrap
          const offcanvasInstance = angularBootstrap.Offcanvas.getInstance(offcanvasElement)
          offcanvasInstance?.hide()
        } else {
          // check the body element and remove any classes and styles that may have been added by the previous page
          const body = document.querySelector('body')
          if (body) {
            body.removeAttribute('style')
          }
        }
      }

      // if (this.analytics && event instanceof NavigationEnd) {
      //   logEvent(this.analytics, 'page_view', { page_path: this.router.url })
      // }

    })
  }

  ngOnInit(): void {
    let faviconUrl: string = 'assets/images/favicon.png'
    if ('faviconUrl' in environment) {
      faviconUrl = environment['faviconUrl'] as string
    }
    this.setFavicon(faviconUrl)
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;
    this.document.getElementsByTagName('head')[0].appendChild(link);
  }
}
